import * as React from 'react';
import FooterContact from '@components/Footer/Contact';
import Block from "@layout/Block";
import './index.scss';

interface Props {
    children?: React.ReactNode;
    footerHide?: boolean;
}

const PageContainer = ({children, footerHide}: Props) => {
    const indent = (footerHide) ? '0' : '150';

    return (
        <>
            <div className="container">
                <Block indent={indent}>
                    { children }
                </Block>
                {
                    !footerHide && <FooterContact />
                }
            </div>        
        </>)
};

export default PageContainer;


// WEBPACK FOOTER //
// ./src/components/PageContainer/index.tsx